import { InputHTMLElement } from "components/input/baseHTMLElementInput";
import template from "components/input/password/passwordElement.hbs";
import { Tooltip } from "components/components/tooltip/tooltip";

export class PasswordInputElement extends InputHTMLElement {

  constructor() {
    super();

    const optTemplate = {
      "prefixId": "pi",
      "id": this.getAttribute("_id"),
      "className": "c-password-input__input o-form-component__input  o-form-component__input-group__input",
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
      "maxlength": this.getAttribute("maxlength"),
      "style": this.getAttribute("_style"),
      "autocomplete": this.getAttribute("autocomplete")
    } as any;

    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");

    this.bindEvents();
    Tooltip.bindElement(this);
  }

  private bindEvents(): void {

    this.genericBindEvents();

  }

  public set data(v: string) {
    this.input.value = v?.toString() ?? null;
    this.initialValue.value = this.data;
  }

  public get data(): string {
    let v = this.input.value;
    if (v === "") {
      return null;
    } else {
      return v;
    }
  }
}

export function initPasswordInputWebComponent() {
  window.customElements.define("s6-password-input", PasswordInputElement);
}
